import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { useHistory } from "react-router-dom";
// import FolderNavigation from "../msb/FolderNavigation";
// import ParametersTableSection from "./ParametersTableSection";
// import ParametersPageHeader from "./ParametersPageHeader";
import ParametersTabSection from "./ParametersTabSection";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "MSBs",
        redirectTo: "/msb",
    },
    {
        text: "Manage Parameters",
        redirectTo: "/parameters"
    }
]

function ParametersPage() {

    const history = useHistory();


    useEffect(() => {
        layoutService.setPageTitle('Manage Parameters')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])


    return (
        <>
            <InfoBoxes />
            <ParametersTabSection />
        </>
    );
}


export default withMainLayout(connect()(ParametersPage));
